<template>
  <div class="form-item">
    <button class="lang-select" type="button" @click="enablePopup()">
      {{valueLabel}}
      <span class="glyphicon glyphicon-chevron-down"></span>
    </button>
  </div>
</template>
<script>
import {fieldMixin} from '../../mixin/field'
import {miniFieldMixin} from '../../mixin/minifield'

export default {
  name: "SourceLanguage",
  mixins: [
    fieldMixin,
    miniFieldMixin(function(value){
      return value != ''
    })
  ],
  props: [
    "popup"
  ],
  computed: {
    valueLabel() {
      return (
        this.fieldValue$ == '' ? this.label : this.fieldData['datalist']['options'][this.fieldValue$]['label']
      )
    }
  },
  methods: {
    enablePopup() {
     this.$emit('update:popup', true)
    }
  },
  watch: {
    //külső változtatás figyelése
    fieldValue: function(val) {
      this.fieldValue$ = val
    }
  }
}
</script>
